import React, {Component} from 'react';
import Snackbar from 'material-ui/Snackbar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    successColor: {
        color: "#52602B",
    },
    errorColor: {
        color: "#F44336"
    }
};

class Signup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSignUp: false,
            checkName: false,
            checkCompanyname: false,
            checkTel: false,
            checkPass: false,
            checkPass2: false,
            checkMail: false,
            mailBlur: false,
            passBlur: false,
            formChange: false,
            nameError: true,
            companynameError: true,
            telError: true,
            mailError: true,
            passError: true,
            passError2: true,
            passChange: false,
            passChange2: false,
            telChange: false,
            mailChange: false,
            open: false,
            passValue: "",
            passValue2: "",
            checkAdres: "",
            adressError: true,
        }
    }

    checkName(e) {
        if (e.target.value.length > 1) {
            this.setState({
                checkName: true,
                nameError: false,
            });
        } else {
            this.setState({
                checkName: false,
                nameError: true,
            })
        }
    }

    checkCompanyname(e) {
        if (e.target.value.length > 1) {
            this.setState({
                checkCompanyname: true,
                companynameError: false,
            })
        } else {
            this.setState({
                checkCompanyname: false,
                companynameError: true,
            })
        }
    }

    checkTel(e) {
        let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        e.target.value = e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

        if (e.target.value.length === 14) {
            this.setState({
                checkTel: true,
                telError: false,
                telChange: true
            })
        } else {
            this.setState({
                checkTel: false,
                telError: true,
                telChange: true
            })
        }
    }

    checkMail(el) {
        let element = el.target;
        let regex = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

        let newEl = regex.test(element.value);

        if (newEl) {
            this.setState({
                checkMail: true,
                mailError: false,
                mailChange: true
            });
        } else {
            this.setState({
                checkMail: false,
                mailError: true,
                mailChange: true
            });
        }
    }

    checkPass(e) {
        this.setState({
            passValue: e.target.value,
        });

        if (e.target.value !== this.state.passValue) {
            this.setState({
                passError3: true,
            })
        } else {
            this.setState({
                passError3: false,
            })
        }

        if (e.target.value.length < 6) {
            this.setState({
                passError: true,
                checkPass: false,
                passChange: true,
            })
        } else {
            this.setState({
                passError: false,
                checkPass: true,
                passChange: true,
            })
        }
    }

    checkPass2(e) {
        if (e.target.value !== this.state.passValue) {
            this.setState({
                passError3: true,
            })
        } else {
            this.setState({
                passError3: false,
            })
        }


        if (e.target.value.length < 6) {
            this.setState({
                passError2: true,
                checkPass2: false,
                passChange2: true,
            })
        } else {
            this.setState({
                passError2: false,
                checkPass2: true,
                passChange2: true,
            })
        }
    }

    formChange() {
        this.setState({
            formChange: true,
        });
    }

    formSubmitClick(event) {
        event.preventDefault();

        let user = {
            username: document.querySelector('#signup-name').value,
            companyname: document.querySelector('#signup-companyname').value,
            companymail: document.querySelector('#signup-mail').value,
            companypass: document.querySelector('#signup-password').value,
            companytel: document.querySelector('#signup-tel').value,
            companyadress: document.querySelector('#signup-company-adress').value,
        };

        fetch('https://saydamalbum.com/saydamWebservice/companyAdd.php', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "ownerName=" + user.username
            + "&companyName=" + user.companyname
            + "&companyMail=" + user.companymail
            + "&companyPassword=" + user.companypass
            + "&companyPhone=" + user.companytel
            + "&companyAdress=" + user.companyadress
        }).then((response) => {
            return response.json();
        }).then((data) => {
            this.setState({
                open: true,
                submitMessage: data.responseMessage
            });

            if (data.responseType === 200) {

                localStorage.setItem("ownerName", user.username);
                localStorage.setItem("companyName", user.companyname);
                localStorage.setItem("companyMail", user.companymail);
                localStorage.setItem("companyPhone", user.companytel);
                localStorage.setItem("companyAdress", user.companyadress);

                setTimeout(() => {
                    document.querySelector('#signUpForm').submit()
                }, 2000);
            }
        });

    }

    checkAdress(e) {
        if (e.target.value.length > 1) {
            this.setState({
                checkAdres: true,
                adressError: false,
            });
        } else {
            this.setState({
                checkAdres: false,
                adressError: true,
            })
        }
    }

    snackbarClose = () => {
        this.setState({
            open: false,
        });
    };


    render() {
        let returnedPass = this.state.checkPass ? "Parolanız uygun" : "6 karakterdan uzun bir parola giriniz";
        let returnedMail = this.state.checkMail ? "Mail adresiniz uygun görünüyor" : "Lütfen geçerli bir mail adresi giriniz";
        let returnedTel = this.state.checkTel ? "Telefon numaranız uygun görünüyor" : "Lütfen geçerli bir telefon numarası giriniz";


        let passColor2 = "";
        let returnedPass2 = "";
        if (this.state.passError3) {
            returnedPass2 = this.state.checkPass2 ? "Parolalarınız uyuşmuyor." : "Parolalarınız uyuşmuyor ve lütfen 6 karakterdan uzun bir parola giriniz";
            passColor2 = styles.errorColor;
        } else {
            returnedPass2 = this.state.checkPass2 ? "Parolanız uygun" : "6 karakterdan uzun bir parola giriniz";
            passColor2 = !this.state.checkPass2 ? styles.errorColor : styles.successColor;
        }

        let passColor = !this.state.checkPass ? styles.errorColor : styles.successColor;
        let mailColor = !this.state.checkMail ? styles.errorColor : styles.successColor;
        let telColor = !this.state.checkTel ? styles.errorColor : styles.successColor;

        return (
            <form className="signUp" id="signUpForm"
                  onChange={this.formChange.bind(this)}>
                <h4><span> Firma Kayıt </span></h4>

                <div className="text-center">
                    <TextField
                        errorText=""
                        floatingLabelStyle={{ color: "#2c3e50" }}
                        floatingLabelText="İsminiz & Soyisminiz"
                        type="text"
                        id="signup-name"
                        onChange={this.checkName.bind(this)}
                    />
                </div>

                <div className="text-center">
                    <TextField
                        errorText=""
                        floatingLabelStyle={{ color: "#2c3e50" }}
                        floatingLabelText="Firma İsminiz"
                        type="text"
                        id="signup-companyname"
                        onChange={this.checkCompanyname.bind(this)}
                    />
                </div>

                <div className="text-center">
                    <TextField
                        errorText={this.state.mailChange ? returnedMail : "" }
                        errorStyle={!this.state.checkMail ? styles.errorColor : styles.successColor}
                        floatingLabelStyle={this.state.mailChange ? mailColor : {}}
                        floatingLabelText="E-Posta Adresiniz"
                        type="email"
                        id="signup-mail"
                        onChange={this.checkMail.bind(this)}

                    />
                </div>

                <div className="text-center">
                    <TextField
                        errorText={this.state.passChange ? returnedPass : ""}
                        errorStyle={!this.state.checkPass ? styles.errorColor : styles.successColor}
                        floatingLabelStyle={this.state.passChange ? passColor : {}}
                        floatingLabelText="Parolanız"
                        type="password"
                        id="signup-password"
                        onChange={this.checkPass.bind(this)}
                    />
                </div>

                <div className="text-center">
                    <TextField
                        errorText={this.state.passChange2 ? returnedPass2 : ""}
                        errorStyle={this.state.passChange2 ? passColor2 : ""}
                        floatingLabelStyle={this.state.passChange2 ? passColor2 : {}}
                        floatingLabelText="Parolanız (Tekrar)"
                        type="password"
                        id="signup-password-again"
                        onChange={this.checkPass2.bind(this)}
                    />
                </div>

                <div className="text-center">
                    <TextField
                        errorText={this.state.telChange ? returnedTel : ""}
                        errorStyle={!this.state.checkTel ? styles.errorColor : styles.successColor}
                        floatingLabelStyle={this.state.telChange ? telColor : {}}
                        floatingLabelText="Telefon Numaranız"
                        type="tel"
                        id="signup-tel"
                        onChange={this.checkTel.bind(this)}
                    />
                </div>

                <div className="text-center address-section">
                    <TextField
                        floatingLabelText="Firma Adresi"
                        type="text"
                        id="signup-company-adress"
                        onChange={this.checkAdress.bind(this)}
                        multiLine={true}
                        rows={2}
                        rowsMax={4}
                    />
                </div>

                <div className="text-center">
                    <div className="text-center buttonDiv">
                        <RaisedButton
                            label="Kayıt Ol"
                            labelPosition="before"
                            icon={<i className="material-icons">send</i>}
                            backgroundColor="#2c3e50"
                            color="#fff"
                            onClick={this.formSubmitClick.bind(this)}
                            type="submit"
                            disabled={
                                !(this.state.formChange &&
                                !this.state.nameError &&
                                !this.state.companynameError &&
                                !this.state.telError &&
                                !this.state.mailError &&
                                !this.state.passError &&
                                !this.state.passError2 &&
                                !this.state.passError3 &&
                                !this.state.adressError
                            )}
                        />
                    </div>
                </div>


                <Snackbar
                    open={this.state.open}
                    message={this.state.submitMessage}
                    autoHideDuration={4000}
                    onRequestClose={this.snackbarClose}
                />
            </form>
        );
    }
}

export default Signup;
